import sdkInstanceProvider from "../../providers/sdkInstanceProvider";
import { SdkError } from "../errors";
import { PRIORITY_BACK_IN_STOCK } from "./constants";

export default async () => {
  const sdkInstance = await sdkInstanceProvider("loyalty");
  try {
    const currentTierId = await sdkInstance.getCustomerTierId();

    if (!currentTierId) {
      return false;
    }
    const isPriority = await sdkInstance.isBenefitAvailableForTier(
      currentTierId,
      PRIORITY_BACK_IN_STOCK
    );

    return Promise.resolve(isPriority);
  } catch (error) {
    if (error.name !== "LoyaltyNotSupportedError") {
      throw new SdkError(error);
    }
  }
};
